/**
* Card Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Card Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'card-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.card-hero' ).each( function() {
        const video = $( this ).find( '.loop-video' );
        $( this ).find( '#card-hero_video-audio__button' ).on( 'click', function() {
          $( this ).toggleClass( 'not-muted' );
          if ( video.prop( 'muted' ) ) {
            video.prop( 'muted', false );
          } else {
            video.prop( 'muted', true );
          }
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-hero', COMPONENT );
} )( app );
